export default __webpack_public_path__ + "static/media/sangini-logo.151af9e0.png";